import mitt from 'mitt';

const emitter = mitt();

export const EventBus = {
    $on: (event, handler) => {
        emitter.on(event, handler);
    },
    $off: (event, handler) => {
        emitter.off(event, handler);
    },
    $emit: (event, payload) => {
        emitter.emit(event, payload);
    },
};
